import {PetersIndex} from '../../basket/classes/peters_index.js';
import * as Helper from '../../weave/helpers.mjs';
import {Modal} from '../../weave/modal.mjs';

class ListIndex extends PetersIndex {
    onFilter(e) {
        const formElement = e.target.closest('[name="index"]');
        const orderdir = formElement.querySelector(".orderdir");
        if (e.currentTarget.classList.contains("orderby")) {
            var val = e.currentTarget.options[e.currentTarget.selectedIndex].value;
            if (val == "title" || val == "sharedby") {
                orderdir.value = "asc";
            }
        }

        var formData = new FormData(formElement);

        const url = formElement.action;
        this.loadingSpinner();
        
        fetch(url, {
            body: formData,
            method: 'POST'
        }).then(response => {
            return response.text();
        }).then(text => {
            this.setListHtml(text);
        });
    }

    onSearch(e) {
        const formElement = e.target.closest('[name="index"]');
        var formData = new FormData(formElement);

        const url = formElement.action;
        this.loadingSpinner();
        
        fetch(url, {
            body: formData,
            method: 'POST'
        }).then(response => {
            return response.text();
        }).then(text => {
            this.setListHtml(text);
        });
    }

    init() {
        document.querySelectorAll('.form-filter .form-select, .form-filter .form-input').forEach(el => {
            el.addEventListener('change', this.onFilter.bind(this));
        });
        document.querySelectorAll('tr.clickableRow').forEach(el => {
            el.addEventListener('click', e => {
                if (e.target.tagName === "TD") {
                    window.location = '/search-results?searchListId=' + el.dataset.id + '&' + el.dataset.title;
                }
            });
        });
        document.querySelectorAll(".sortOrderIcon").forEach(el => {
            el.addEventListener('click', (e) => {
                const form = e.target.closest("form");
                const orderdir = form.querySelector('.orderdir');
                if (orderdir.value == "desc") {
                    orderdir.value = "asc";
                } else {
                    orderdir.value = "desc";
                }
                this.onFilter(e);
            });
        });
        document.querySelector("#bookListSearch").addEventListener('change', this.onSearch.bind(this));
        document.querySelector("#bookListSearch").addEventListener('keypress', (e) => {
            if (e.keyCode == 13) {
                e.preventDefault();
                this.onSearch(e);
            }
        });

        // $('.bookImg').on('error', function(){
        //     $(this).off();
        //     if($(this).hasClass('centerfoldImage')) {
        //         $(this).remove();
        //     } else {
        //         $(this).attr('src', "/assets/img/nocover.png");
        //     }
        // });
        
        this.initCarousels(false);
    }
}

export { ListIndex };